import React from 'react';
// @ts-ignore
import styles from './InsuranceReportsListItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import {
	InsuranceReport,
	useDeleteInsuranceReportMutation,
} from '../../../../graphql/graphql';
import InsuranceReportsListSubItem from './InsuranceReportsListSubItem';
import {
	STATE_ERROR_TRANSLATIONS,
	STATE_TRANSLATIONS,
	formatInsuranceReportNote,
} from '../ManagerInsuranceReportList/ManagerInsuranceReportListItem';
import useDateFormatter from '../../../../Hooks/useDateFormatter';

interface Props {
	item: InsuranceReport;
	onDelete: () => void;
}

const InsuranceReportsListItem: React.FC<Props> = ({ item, onDelete }) => {
	const [deleteInsuranceReport] = useDeleteInsuranceReportMutation();
	const { formatDate } = useDateFormatter();

	const handleRemoveInsuranceReport = async () => {
		await deleteInsuranceReport({ id: item.id });
		onDelete();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.content}>
				<InsuranceReportsListSubItem
					title='component.insuranceReportsListItem.date'
					value={formatDate(item.reportedAt)}
				/>
				{item.doctor?.profile?.fullName && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.doctor'
						value={item.doctor?.profile?.fullName}
					/>
				)}
				{item.diagnosis && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.diagnosis'
						value={item.diagnosis}
					/>
				)}
				{item.operation?.title && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.operation'
						value={item.operation.title}
					/>
				)}
				{item.count && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.count'
						value={item.count}
					/>
				)}
				{item.points && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.points'
						value={item.points}
					/>
				)}
				{item.state && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.state'
						value={STATE_TRANSLATIONS[item.state]}
					/>
				)}
				{item.stateError && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.stateError'
						value={STATE_ERROR_TRANSLATIONS[item.stateError]}
					/>
				)}
				{item.note && (
					<InsuranceReportsListSubItem
						title='component.insuranceReportsListItem.note'
						value={formatInsuranceReportNote(item.note)}
					/>
				)}
			</div>
			<div className={styles.controls}>
				<RemoveButton
					title='base.shared.delete'
					onClick={handleRemoveInsuranceReport}
				/>
			</div>
		</div>
	);
};

export default InsuranceReportsListItem;
